import { Activation } from "@/types";

export const LOAD_ACTIVATION = "LOAD_ACTIVATION";
export const CHANGE_ACTIVATION = "CHANGE_ACTIVATION";
export const SHARE_ACTIVATION = "SHARE_ACTIVATION";

export type ActivationAction =
  | { type: typeof LOAD_ACTIVATION; payload: Activation | null }
  | { type: typeof CHANGE_ACTIVATION; payload: Partial<Activation> }
  | { type: typeof SHARE_ACTIVATION; payload: { campaignId: string; userIds: number[] } };

/** The activation being viewed or edited. Fetched activations live in the query cache. */
export interface ActivationState {
  currentActivation: Activation | null;
}

export const initialState: ActivationState = {
  currentActivation: null,
};
